// eslint-disable-next-line
import { injectable } from "inversify";
import {
    IIntegrationCategoryPreset,
    IShippingConnection,
    IShippingOauthLinkResponse,
    SHIPPING_CONNECTION_CODE
} from "../../models/IntegrationsTypes";
import { TYPE, rootContainer } from '../container/root';
import { IApiResponse, IHttpService } from "../http-service";
import { IAggregatorInfo } from "../../pages/return-methods/return-method-types";
import {WithOld} from "../../stores/types";

export interface IIntegrationsService { }

interface IShippingIntegrationsSettings {
    aggregators_info: IAggregatorInfo[];
}

export interface IShippingIntegrationsData {
	list: IShippingConnection[];
	settings: IShippingIntegrationsSettings;
}

export interface ICreateOauthLinkBody {
    is_sandbox: boolean;
    credentials?: Record<string, any>;
}

@injectable()
class ShippingIntegrationsService implements IIntegrationsService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async getIntegrationsPresets(): Promise<IIntegrationCategoryPreset[]> {
        const res = await this.httpService.get<IApiResponse<IIntegrationCategoryPreset[]>>('/rms-api/integrations/presets');
        return res.payload;
    }

    async getIntegrations(): Promise<IShippingIntegrationsData> {
        const res = await this.httpService.get<IApiResponse<IShippingIntegrationsData>>('/rms-api/integrations-shipping');
        return res.payload;
    }

    async registerIntegration<CredentialsType>(credentials: CredentialsType, service_code: string, service_type: string, is_sandbox: boolean): Promise<IShippingConnection> {
        const res = await this.httpService.post<IApiResponse<IShippingConnection>>('/rms-api/integrations-shipping/register', {
            credentials,
            service_code,
            service_type,
            is_sandbox,
        });
        return res.payload;
    }

    async removeIntegration(id: number): Promise<IShippingConnection> {
        const res = await this.httpService.remove<IApiResponse<IShippingConnection>>(`/rms-api/integrations-shipping/${id}`);
        return res.payload;
    }

    async updateIntegration(id: number, integration: WithOld<IShippingConnection>): Promise<IShippingConnection> {
        const res = await this.httpService.put<IApiResponse<IShippingConnection>>(`/rms-api/integrations-shipping/${id}`, {
            ...integration,
        });
        return res.payload;
    }

    async createOauthLink(serviceCode: SHIPPING_CONNECTION_CODE, body: ICreateOauthLinkBody): Promise<IShippingOauthLinkResponse> {
        const res = await this.httpService.post<IApiResponse<IShippingOauthLinkResponse>>(`/rms-api/integrations-shipping/create-oauth-link/${serviceCode}`, body);
        return res.payload;
    }

    async fedexV2ValidateAddress(body: Record<string, unknown>) {
        const res = await this.httpService.post<IApiResponse<any>>('/rms-api/integrations-shipping/fedex-v2/registration/validate-address', body);
        return res.payload;
    }

    async fedexV2GeneratePin(body: Record<string, unknown>) {
        const res = await this.httpService.post<IApiResponse<any>>('/rms-api/integrations-shipping/fedex-v2/registration/generate-pin', body);
        return res.payload;
    }

    async fedexV2ValidatePin(body: Record<string, unknown>) {
        const res = await this.httpService.post<IApiResponse<any>>('/rms-api/integrations-shipping/fedex-v2/registration/validate-pin', body);
        return res.payload;
    }
}

export default ShippingIntegrationsService;
